import { Routes, Route } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';
import RouteAdapter from './utils/route-adapter';
import { Pages } from './domain/enums/pages';
import TourneyPagesEditPage from 'modules/tourneys/ui/pages/edit';
import TourneyPagesCreatePage from 'modules/tourneys/ui/pages/create';
import MainPagesIndex from 'modules/main/ui/pages/index';
import AuthPagesSignUp from 'modules/auth/ui/pages/sign-up';
import AuthPagesSignIn from 'modules/auth/ui/pages/sign-in';
import AuthPagesSelectTournament from 'modules/auth/ui/pages/select-tournament/select-tournament';
import SecureRoute from './ui/components/secure-route';
import SettingsPage from '../main/ui/pages/settings-page';
import TeamsPage from '../teams/ui/pages/teams-page';
import TeamsCreatePage from '../teams/ui/pages/teams-create-page';
import TeamsEditPage from '../teams/ui/pages/team-edit-page';

const AppRouter = () => {
  return (
    <QueryParamProvider ReactRouterRoute={RouteAdapter}>
      <Routes>
        <Route
          path={Pages.INDEX}
          element={
            <SecureRoute>
              <MainPagesIndex />
            </SecureRoute>
          }
        />
        <Route
          path={Pages.SETTINGS}
          element={
            <SecureRoute tournamentRequired={false}>
              <SettingsPage />
            </SecureRoute>
          }
        />
        <Route path={Pages.SIGN_UP} element={<AuthPagesSignUp />} />
        <Route path={Pages.SIGN_IN} element={<AuthPagesSignIn />} />
        <Route
          path={Pages.SELECT_TOURNAMENT}
          element={<AuthPagesSelectTournament />}
        />
        <Route
          path={Pages.TOURNEYS.INDEX}
          element={
            <SecureRoute>
              <MainPagesIndex />
            </SecureRoute>
          }
        />
        <Route
          path={`${Pages.TOURNEYS.CREATE}`}
          element={
            <SecureRoute>
              <TourneyPagesCreatePage />
            </SecureRoute>
          }
        />
        <Route
          path={`${Pages.TOURNEYS.EDIT}/*`}
          element={
            <SecureRoute>
              <TourneyPagesEditPage />
            </SecureRoute>
          }
        >
          {/*<Route path={Pages.TOURNEYS.INDEX} element={<SecureRoute><MainPagesIndex /></SecureRoute>} />*/}
        </Route>

        <Route
          path={Pages.TEAMS.INDEX}
          element={
            <SecureRoute>
              <TeamsPage />
            </SecureRoute>
          }
        />
        <Route
          path={Pages.TEAMS.CREATE}
          element={
            <SecureRoute>
              <TeamsCreatePage />
            </SecureRoute>
          }
        />
        <Route
          path={`${Pages.TEAMS.EDIT}/*`}
          element={
            <SecureRoute>
              <TeamsEditPage />
            </SecureRoute>
          }
        />
      </Routes>
    </QueryParamProvider>
  );
};
export default AppRouter;
